<template>
	<div>
		<div v-if="!smallScreen">
			<nav v-if="activeRouteName !== 'Error404' && activeRouteName !== 'AutoLogin' && activeRouteName !== 'InvitationCollaborators' && activeRouteName !== 'SharedMisc'" class="navbar navbar-main navbar-expand-lg sticky-top hidden-sm" :class="{ 'shrink': shrink }">
				<div class="container-fluid" :class="activeRouteName === 'RundownCommandEditor' ? 'p-0': ''">
					<router-link class="navbar-brand mr-4" to="/" v-if="activeRouteName !== 'RundownEditor' &&  activeRouteName !== 'RundownCommandEditor'">
						<img src="/img/icon-512.png" class="d-inline-block align-top" alt="Grafias">
					</router-link>
					<div class="navbar-brand mr-3 pointer" @click="goToCommandRundown(`/rundowns/editor/${activeRouteSlug}`)" v-if="activeRouteName === 'RundownCommandEditor'">
						<img src="/img/icon-512.png" class="d-inline-block align-top" alt="Grafias">
					</div>
					<!-- menu popup rundown -->
					<button
						v-if="activeRouteName === 'RundownEditor'"
						type="button"
						class="btn-icon btn-brand-composition btn"
						v-click-outside="hideContext" @click="toggleContextDashboard()" ref="dropdownContextDashboard">
						<img src="/img/icon-512.png" class="navbar-brand-composition" alt="Grafias">
						<i class="material-icons pb-1 mt-1 ml-2">expand_more</i>
					</button>
					<ul v-if="dashboardOpened" class="dropdown-context-dashboard-item">
						<li class="text-white-context pl-4 pb-2 pt-2" @click="goTo('/')">
							<label class="link-white-nodecor pointer">{{ $t('Dashboard') }}</label>
						</li>
						<li @click="isProgramMonitorVisible = true" class="text-white-context pl-4 pb-2 pt-2">
							<label class="link-white-nodecor">{{ $t('Device Monitor') }}</label>
						</li>
						<li class="text-white-context pl-4 pb-2 pt-2" @click="goTo('/compositions')">
							<label class="link-white-nodecor pointer pt-0 mt-0">{{ $t('Composition') }}</label>
						</li>
						<li class="text-white-context pl-4 pb-2 pt-2" @click="goTo('/displays')">
							<label class="link-white-nodecor">{{ $t('View Output') }}</label>
						</li>
					</ul>
					<div class="navbar-separator ml-0"></div>
					<div class="nav-page-title" v-if="activeRouteName !== 'RundownEditor'">{{ title }}</div>
					<div @dblclick="isRenameVisible = true" class="nav-page-title pointer"
						v-if="activeRouteName === 'RundownEditor'"
						v-click-outside="hideContextRundown" @contextmenu.prevent @contextmenu="toggleContextRundown()" ref="dropdownContextRundown">
						{{ rundown && nameRundown ? nameRundown : '' }}
						<ul v-if="rundownOpened" class="dropdown-context-rundown-main-item">
							<li class="text-white-context pl-4 pb-2 pt-2" @click="goTo('/')">
							{{$t('All Rundown')}}
							</li>
							<li class="text-white-context pl-4 pb-2 pt-2" @click="confirmCreateRundown(true)">
								{{$t('New Rundown')}}
							</li>
							<li class="text-white-context pl-4 pb-2 pt-2" v-for="item in rundowns" :key="item.id">
								<label class="text-white pr-4" @click="goToRundown(item.slug)">{{item.name}}</label>
							</li>
						</ul>
					</div>

					<!-- main nav -->
					<div></div>
					<button type="button" class="navbar-toggler">
						<span class="navbar-toggler-icon"></span>
					</button>
					<div class="main-nav-dropdown collapse navbar-collapse justify-content-between">
						<ul class="navbar-nav d-flex justify-content-center">
							<li class="nav-item hidden" :class="{ 'active': isMenuActive('/') }">
								<router-link class="nav-link nav-link-text" to="/">
									<!-- <span class="link-label">{{ $t('menu.home') }}</span> -->
								</router-link>
							</li>
						</ul>
						<ul class="navbar-nav">
							<li v-if="user && !isCollaborator && activeRouteName !== 'RundownEditor' && activeRouteName !== 'PromoUID' && !isFinance && activeRouteName !== 'RundownCommandEditor' ">
								<a class="btn btn-primary text-white mr-3 mt-2" :class="{ 'is-loading': isCreatingRundown }" @click="confirmCreateRundown(false)">
									{{ $t('New Rundown') }}
								</a>
							</li>
							<li v-if="user && !isCollaborator && activeRouteName !== 'RundownEditor' && activeRouteName !== 'PromoUID' && !isFinance && activeRouteName !== 'RundownCommandEditor'  || isUserCollaboratorOperator && !isFinance && activeRouteName !== 'RundownCommandEditor' ">
								<router-link
									class="btn btn-primary text-white mr-3 mt-2"
									to="/compositions/editor">
									{{ $t('New Composition') }}
								</router-link>
							</li>
							<li v-if="user && !isCollaborator && activeRouteName !== 'RundownEditor' && activeRouteName !== 'PromoUID' && !isFinance && activeRouteName !== 'RundownCommandEditor' ">
								<a
									class="btn btn-primary text-white mt-2"
									@click="addProgramMonitor">
									{{ $t('Device Monitor') }}
								</a>
							</li>
							<!-- display menu -->
							<li>
								<button v-if="activeRouteName === 'RundownEditor' && userCollaborators !== 'event_manager' && activeRouteName !== 'RundownCommandEditor'"
									type="button"
									:class="{ 'is-loading': isFetching }"
									v-click-outside="hideContextDisplay" ref="dropdownContextDisplay"
									class="btn btn-primary btn-display-output btn-icon" @click.stop="fetchDisplay()">
									<i class="material-icons">monitor</i>
									<label class="mt-2">View output</label>
									<i v-if="!isFetching" class="material-icons pb-1 mt-1">expand_more</i>
									<ul v-if="displayOpened" class="dropdown-context-display-item">
										<!-- Attach Display Output -->
										<li @click.stop="addOutputDisplay" class="text-white-context pl-4 pr-4 pt-2 text-left">
											{{ $t('Manage Output') }}
										</li>
										<li v-if="!isFetching && filteredDisplay.length > 0" class="pb-2 mt-2 text-left">
											<div class="p-5 text-center" v-if="isFetching">
												<div class="is-loading large"></div>
											</div>
											<span class="text-grey pl-4 pr-4">{{ $t('Active Output') }}</span>
										</li>
										<ul v-for="item in displaysActive" :key="item.id" class="nonstyle pl-0">
											<li v-if="item.rundown_id === rundown.id && !isFetching" class="text-white-context text-left"
												@click.stop="viewDisplay(item)">
												<button-broadcast :data="item" @saved="insertItem"></button-broadcast>
											</li>
										</ul>
									</ul>
								</button>
							</li>
							<!-- stop all -->
							<li v-if="activeRouteName === 'RundownCommandEditor'">
								<button
									type="button"
									class="btn btn-danger-outline mt-1 mr-5"
									style="height: 40px;"
									:class="{ 'is-loading': isStopping }"
									@click="stopAll">
									{{ $t('Stop All') }}
								</button>
							</li>
							<!-- clock item -->
							<li v-if="activeRouteName === 'RundownEditor' || activeRouteName === 'RundownCommandEditor'" ></li>
							<li class="clock-time ml-3 minw-50">
								<div :class="activeRouteName === 'RundownCommandEditor' ? 'mr-7' : ''" class="text-center">{{ clockTime }}</div>
							</li>
							<li v-if="activeRouteName !== 'RundownCommandEditor'">
								<profile-dropdown></profile-dropdown>
							</li>
							<!-- Profile -->
							<li class="nav-item dropdown profile-menu hidden" v-if="user">
								<div class="nav-link p-0">
									<md-menu md-size="big" md-direction="bottom-end" md-align-trigger>
										<md-button class="btn-fluid ml-3" v-tooltip="fullname" :md-ripple="false" md-menu-trigger>
											<div class="flex-center-left">
												<span class="mr-2 pt-1">{{ user.name }}</span>
												<div
													class="profile-image"
													:style="{ backgroundImage: `url('${user.picture}')` }"
													v-if="user.picture && user.picture !== ''">
												</div>
												<i class="material-icons profile-image" v-else>account_circle</i>
											</div>
										</md-button>
										<md-menu-content>
											<md-menu-item @click="$router.push('/profile')">{{ $t('Profile') }}</md-menu-item>
											<md-menu-item @click="logout()">{{ $t('Logout') }}</md-menu-item>
										</md-menu-content>
									</md-menu>
								</div>
							</li>
							<!-- Help -->
							<li class="nav-item m-0 hidden">
								<a class="nav-link help-toggle cur-p" v-tooltip="$t('Help')" @click="showHelp">
									<div class="help-icon icon-toggle">
										<i class="material-icons">help</i>
									</div>
									<!-- <div class="label ml-2">Help</div> -->
								</a>
							</li>
						</ul>
						<!-- program monitor -->
						<modal-program-monitor
						@close="isProgramMonitorVisible = false"
						v-if="isProgramMonitorVisible">
						</modal-program-monitor>
						<modal-output-display
						@close="isOutputDisplayVisible = false"
						v-if="isOutputDisplayVisible">
						</modal-output-display>
					</div>
				</div>
				<!-- Rename Rundown -->
					<modal class="absolute"
						@close="isRenameVisible = false"
						v-if="isRenameVisible">
						<template slot="header">
							<h3>{{ $t('Rename Rundown') }}</h3>
						</template>
						<template slot="body">
							<div class="form-group mb-3">
								<input
									type="text"
									class="form-control"
									:placeholder="$t('Rundown Name')"
									v-model="nameRundown"
								/>
							</div>
						</template>
						<template slot="footer">
							<button
								type="button"
								class="btn btn-primary"
								:class="{ 'is-loading': isSavingRundown }"
								@click="update">
								{{ $t('Save') }}
							</button>
							<button
								type="button"
								class="btn btn-default"
								@click="closeRename">
								{{ $t('Cancel') }}
							</button>
						</template>
					</modal>
			</nav>
		</div>
		<div v-if="smallScreen">
		<nav>
			<nav v-if="activeRouteName !== 'Error404' && activeRouteName !== 'AutoLogin'" class="navbar navbar-main navbar-expand-lg sticky-top" :class="{ 'shrink': shrink }">
				<!-- Profile -->
				<div class="d-flex justify-content-between">
					<div class="ml-a">
						<img @click="goTo('/')" src="/img/icon-512.png" class="navbar-brand-composition" alt="Grafias"> <span class="text-default ml-3 text-xlg" v-if="activeRouteName === 'dashboard'">Rundown</span>
						<div class="profile-dropdown-mobile"><profile-dropdown></profile-dropdown></div>
					</div>
					<div @dblclick="isRenameVisible = true" class="nav-page-title pointer ml-2"
						v-if="activeRouteName === 'RundownEditor'"
						v-click-outside="hideContextRundown" @contextmenu.prevent @contextmenu="toggleContextRundown()" ref="dropdownContextRundown">
						{{ rundown && nameRundown ? nameRundown : '' }}
						<ul v-if="rundownOpened" class="dropdown-context-rundown-main-item">
							<li class="text-white-context pl-4 pb-2 pt-2" @click="goTo('/')">
							{{$t('All Rundown')}}
							</li>
							<li class="text-white-context pl-4 pb-2 pt-2" v-for="item in rundowns" :key="item.id">
								<label class="text-white pr-4" @click="goToRundown(item.slug)">{{item.name}}</label>
							</li>
						</ul>
					</div>
					<!-- <div class="ml-a">
						<profile-dropdown></profile-dropdown>
					</div> -->
				</div>
			</nav>
		</nav>
	</div>
	<!-- Modal Rundown -->
	<modal
		size="small-medium"
		@close="isCreateVisible = false"
		v-if="isCreateVisible"
		>
		<template slot="header">
			{{ $t('Create Rundown') }}
		</template>
		<template slot="body">
			<div class="form-group mb-3">
				<!-- name -->
				<label class="text-primary">{{ $t('Rundown Name') }}</label>
				<input
					type="text"
					class="form-control mb-4"
					v-model="rundownName"
				/>
				<!-- date time -->
				<div class="d-flex">
					<div style="width: 100%">
						<label class="text-primary">{{ $t('Date & Time') }}</label>
						<date-picker
							v-model="dateTime"
							:lang="lang"
							type="datetime"
							placeholder="Select datetime"
							:minute-step="30"
							:default-value="new Date().setHours(9, 0, 0, 0)"
							:disabled-date="notBeforeToday"
							format="DD/MM/YYYY HH:mm"
							valueType="YYYY-MM-DD HH:mm"
							:show-time-panel="showTimePanel"
							@close="handleOpenChange"
						>
							<template v-slot:footer>
							<button class="mx-btn mx-btn-text" @click="toggleTimePanel">
								{{ showTimePanel ? 'select date' : 'select time' }}
							</button>
							</template>
						</date-picker>
					</div>
					<div class="form-group select ml-2" style="width: 100%; max-height: 20px;">
						<label class="text-primary">Status</label>
						<div class="mh-40px">
							<multiselect class="select-input" v-model="status" deselect-label="Can't remove this value" track-by="label" label="label"
								placeholder=" " :options="filteredStatusList" :searchable="true" :allow-empty="false" :show-labels="false">
								<template slot="singleLabel" slot-scope="props">
									<div class="flex-center-left">
										<div :class="`status-dot-${props.option.key || 'pre_production'}`" class="mr-2"></div>
										<div class="option__desc">{{ props.option.label ? props.option.label : 'Pre Production' }}</div>
									</div>
								</template>
								<template slot="option" slot-scope="props">
									<div class="flex-center-left">
										<div :class="`status-dot-${props.option.key}`" class="mr-2" alt="No Man’s Sky"></div>
										<div class="option__desc">{{ props.option.label }}</div>
									</div>
								</template>
								<span class="arrow-multiselect" slot="caret">
									<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
								</span>
								<span slot="noResult">Oops! No package found.</span>
							</multiselect>
						</div>
					</div>
				</div>
				<!-- note -->
				<label class="text-primary mt-3">{{ $t('Notes') }}</label>
				<textarea type="text" name="note" rows="6" class="form-control" maxlength="455"
					v-model="description">
				</textarea>
			</div>
		</template>
		<template slot="footer">
			<button
				type="button"
				class="btn btn-primary"
				:class="{ 'is-loading': isCreatingRundown }"
				:disabled="!rundownName || !dateTime"
				@click="checkCreate()">
				{{ $t('Create') }}
			</button>
			<button
				type="button"
				class="btn btn-default"
				@click="isCreateVisible = false">
				{{ $t('Cancel') }}
			</button>
		</template>
	</modal>
	<calendarView v-show="false" ref="calendarView"></calendarView>
	</div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import { mapGetters, mapActions } from 'vuex';
import displaysApi from '@/api/displays';
import Modal from '@/components/Modal.vue';
import ButtonBroadcast from '@/components/ButtonBroadcast.vue';
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import dayjs from 'dayjs';
import calendarView from '@/views/CalendarView.vue';


import {
	getAxiosErrorMessage,
	copyToClipboard,
	duplicateVar,
} from '@/lib/helper';
import { EventBus } from '@/lib/event-bus';
import rundownsApi from '@/api/rundowns';
import ModalOutputDisplay from './ModalOutputDisplay.vue';
import ModalProgramMonitor from './ModalProgramMonitor.vue';
import ProfileDropdown from './ProfileDropdown.vue';

export default {
	name: 'mainNav',
	components: {
		ProfileDropdown,
		ModalProgramMonitor,
		ModalOutputDisplay,
		Modal,
		ButtonBroadcast,
		Multiselect,
		DatePicker,
		calendarView,
	},
	data() {
		return {
			shrink: false,
			isProgramMonitorVisible: false,
			clockTime: '',
			runTime: '',
			isCreatingRundown: false,
			isOutputDisplayVisible: false,
			rundown: null,
			displaysActive: [],
			isFetching: false,
			isRenameVisible: false,
			isSavingRundown: false,
			nameRundown: '',
			rundowns: [],
			dashboardOpened: false,
			displayOpened: false,
			rundownOpened: false,
			smallScreen: false,

			// create rundown
			isCreateVisible: false,
			rundownName: '',
			description: '',
			status: '',
			dateTime: '',
			lang: {
				formatLocale: {
					firstDayOfWeek: 1,
				},
			},

			// filterstatus
			filterStatus: 'all',
			statusList: [
				{ key: 'all', label: 'All' },
				{ key: 'pre_production', label: 'Pre Production' },
				{ key: 'production', label: 'Production' },
				{ key: 'post_production', label: 'Post Production' },
				{ key: 'archive', label: 'Archive' },
			],

			// date picker
			showTimePanel: false,

			// stop rundown
			isStopping: false,
		};
	},
	directives: {
		ClickOutside,
	},
	sockets: {
		connect() {
		},
		rundown_update(payload) {
			this.rundown = duplicateVar(payload);
			this.nameRundown = payload.name;
		},
	},
	methods: {
		stopAll() {
			this.isStopping = true;
			const callback = () => {
				this.isStopping = false;
			};
			const errorCallback = () => {
				this.isStopping = false;
			};
			rundownsApi.stop(atob(this.activeRouteSlug), callback, errorCallback);
		},
		toggleTimePanel() {
			this.showTimePanel = !this.showTimePanel;
			setTimeout(() => {
				const headline = document.getElementsByClassName('mx-time-header-title');
				headline[0].innerText = dayjs(headline[0].innerText).format('DD/MM/YYYY');
			}, 100);
		},
		handleOpenChange() {
			this.showTimePanel = false;
		},
		toggleContextDashboard() {
			this.dashboardOpened = !this.dashboardOpened;
		},
		toggleContextDisplay() {
			this.displayOpened = !this.displayOpened;
		},
		toggleContextRundown() {
			this.rundownOpened = !this.rundownOpened;
		},
		hideContext() {
			this.dashboardOpened = false;
		},
		hideContextDisplay() {
			this.displayOpened = false;
		},
		hideContextRundown() {
			this.rundownOpened = false;
		},
		...mapActions({
			logout: 'logout',
			switchRole: 'switchRole',
			setSwitcherState: 'setSwitcherState',
			setHelpState: 'setHelpState',
		}),
		handleScroll() {
			const scrollPosition = window.scrollY;
			const treshold = 0;
			if (scrollPosition > treshold) {
				this.shrink = true;
			} else {
				this.shrink = false;
			}
		},
		isUserCan(capability) {
			return this.user && this.user.capabilities.includes(capability);
		},
		showHelp() {
			this.setHelpState(true);
		},
		addProgramMonitor() {
			this.isProgramMonitorVisible = true;
		},
		addOutputDisplay() {
			this.displayOpened = false;
			this.isOutputDisplayVisible = true;
		},
		updateRunTime() {
			const cd = new Date();
			this.runTime = `${this.zeroPadding(cd.getHours(), 2)}:${this.zeroPadding(cd.getMinutes(), 2)}:${this.zeroPadding(cd.getSeconds(), 2)}`;
		},
		updateTime() {
			const cd = new Date();
			let hours = cd.getHours();
			const ampm = hours >= 12 ? 'PM' : 'AM';

			// Convert to 12-hour format
			hours = hours % 12 || 12;

			this.clockTime = `${this.zeroPadding(hours, 2)}:${this.zeroPadding(cd.getMinutes(), 2)}:${this.zeroPadding(cd.getSeconds(), 2)} ${ampm}`;
		},

		zeroPadding(num, digit) {
			let zero = '';
			for (let i = 0; i < digit; i++) {
				zero += '0';
			}
			return (zero + num).slice(-digit);
		},
		createRundown() {
			this.isCreatingRundown = true;
			const callback = (response) => {
				const rundown = response.data;
				if (this.activeRouteName !== 'CalendarView') this.$router.push(`/rundowns/editor/${btoa(rundown.slug)}`);
				if (this.activeRouteName === 'CalendarView') EventBus.$emit('call-method-in-calendar-view');
				this.isCreatingRundown = false;
				this.isCreateVisible = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Rundown',
					text: message,
				});
				this.isCreatingRundown = false;
				this.isCreateVisible = false;
			};
			const params = {
				name: this.rundownName,
				status: this.status.key,
				description: this.description,
				start_time: this.dateTime,
			};
			rundownsApi.create(params, callback, errorCallback);
		},
		copyUrl() {
			const slug = this.activeRouteSlug;
			const url = `${window.location.host}/rundowns/editor/${btoa(slug)}`;
			copyToClipboard(url);
			const message = this.$t('Copied to clipboard');
			this.$notify({
				group: 'app',
				type: 'success',
				title: 'Copy URL',
				text: message,
			});
		},
		getRundownData() {
			if (!this.activeRouteSlug) return;
			const callback = (response) => {
				const rundown = response.data;
				this.rundown = rundown;
				this.nameRundown = this.rundown.name;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Rundown',
					text: message,
				});
			};
			rundownsApi.getBySlug(atob(this.activeRouteSlug), callback, errorCallback);
		},
		fetchDisplay() {
			this.isFetching = true;
			const rundownId = this.rundown && this.rundown.id ? this.rundown.id : null;
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'id',
				sort_by: 'asc',
				rundown_id: rundownId,
			};
			const callback = (response) => {
				const items = response.data;
				this.displaysActive = items;
				this.isFetching = false;
				this.displayOpened = true;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: '',
					text: message,
				});
				this.isFetching = false;
			};
			displaysApi.getList(params, callback, errorCallback);
		},
		viewDisplay(item) {
			this.displayOpened = false;
			const rundownId = item && item.rundown && item.rundown.id ? item.rundown.id : '';
			const url = `/displays/live/${btoa(item.slug)}/${btoa(item.id)}?${btoa('rundown_id=')}${rundownId}`;
			const routeData = this.$router.resolve({ path: url });
			window.open(routeData.href, '_blank');
		},
		update() {
			this.isSavingRundown = true;
			const id = this.rundown.id;
			const name = this.nameRundown.trim();
			const params = {
				name,
			};
			const callback = (response) => {
				const rundown = response.data;
				this.rundown = rundown;
				this.$router.push(`/rundowns/editor/${btoa(rundown.slug)}`).catch(() => {});
				this.isSavingRundown = false;
				this.isRenameVisible = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Update Rundown',
					text: message,
				});
				this.isSavingRundown = false;
			};
			rundownsApi.update(id, params, callback, errorCallback);
		},
		closeRename() {
			this.isRenameVisible = false;
			this.rundown.name = '';
		},
		goTo(route) {
			this.$router.push(route);
			this.dashboardOpened = false;
		},
		goToRundown(route) {
			const routeData = this.$router.resolve(`/rundowns/editor/${btoa(route)}`);
			window.open(routeData.href, '_self');
			this.hideContextRundown();
		},
		createRundown2() {
			this.isCreatingRundown = true;
			const callback = (response) => {
				const rundown = response.data;
				if (this.activeRouteName !== 'CalendarView') {
					const routeData = this.$router.resolve(`/rundowns/editor/${btoa(rundown.slug)}`);
					window.open(routeData.href, '_blank');
				} else {
					EventBus.$emit('call-method-in-calendar-view');
				}
				this.isCreatingRundown = false;
				this.isCreateVisible = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Rundown',
					text: message,
				});
				this.isCreatingRundown = false;
				this.isCreateVisible = false;
			};
			const params = {
				name: this.rundownName,
				status: this.status.key,
				description: this.description,
				start_time: this.dateTime,
			};
			rundownsApi.create(params, callback, errorCallback);
		},
		fetchRundown() {
			const params = {
				page: 1,
				limit: 5,
				order_by: 'id',
				sort_by: 'desc',
				user_id: this.userId,
			};
			const callback = (response) => {
				const rundowns = response.data;
				this.rundowns = rundowns;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Rundown',
					text: message,
				});
			};
			rundownsApi.getList(params, callback, errorCallback);
		},
		onClick(e) {
			const el = this.$refs.dropdownContextDashboard;
			const isElementExist = el && el !== undefined;
			const target = e.target;
			if (e.target && isElementExist) {
				if ((el !== target) && !el.contains(target)) {
					this.dashboardOpened = false;
					this.displayOpened = false;
				}
			}
		},
		onClickRundown(e) {
			const el = this.$refs.dropdownContextRundown;
			const isElementExist = el && el !== undefined;
			const target = e.target;
			if (e.target && isElementExist) {
				if ((el !== target) && !el.contains(target)) this.rundownOpened = false;
			}
		},
		onResizeWidth() {
			if (window.innerWidth <= 1024) {
				this.smallScreen = true;
			} else {
				this.smallScreen = false;
			}
		},
		joinSocket() {
			if (this.activeRouteSlug) {
				const roomId = `rundown_${atob(this.activeRouteSlug)}`;
				this.$socket.client.emit('join', roomId);
			}
		},
		leaveSocket() {
			if (this.activeRouteSlug) {
				const roomId = `rundown_${atob(this.activeRouteSlug)}`;
				this.$socket.client.emit('leave', roomId);
			}
		},
		insertItem(item) {
			const index = this.displaysActive.findIndex(({ id }) => id === item.id);
			if (index === -1) {
				this.displaysActive.push(item);
			} else {
				this.$set(this.displaysActive, index, item);
			}
		},
		confirmCreateRundown(isInsideRundown) {
			this.isInsideRundown = isInsideRundown;
			this.rundownName = '';
			const now = new Date();
			const oneWeekLater = new Date(now);
			oneWeekLater.setDate(now.getDate() + 7);
			oneWeekLater.setHours(9, 0, 0, 0); // Setting the time to 9:00 AM
			this.dateTime = dayjs(oneWeekLater).format('YYYY-MM-DD HH:mm');
			this.status = { key: 'pre_production', label: 'Pre Production' };
			this.description = '';
			this.isCreateVisible = true;
		},

		checkCreate() {
			if (this.isInsideRundown) {
				this.createRundown2();
				return;
			}
			this.createRundown();
		},

		rundownFilterUpdate(status) {
			this.filterStatus = status;
			this.fetchData(true);
		},

		formatStatus(status) {
			return status.replace(/\b\w/g, (match) => match.toUpperCase()).replace('_', ' '); // Replace underscores with space
		},

		notBeforeToday(date) {
			return date < new Date(new Date().setHours(0, 0, 0, 0));
		},
		goToCommandRundown(route) {
			const routeData = this.$router.resolve(route);
			window.open(routeData.href, '_self');
			this.hideContextRundown();
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			role: 'role',
			isMenuActive: 'isMenuActive',
			isSuperAdmin: 'isSuperAdmin',
			isClient: 'isClient',
			isCollaborator: 'isCollaborator',
			isFinance: 'isFinance',
		}),
		fullname() {
			return this.user.name;
		},
		roles() {
			return this.user ? this.user.roles : [];
		},
		userId() {
			return this.user ? this.user.id : '';
		},
		title() {
			return this.$route.meta.gtm || 'Grafias';
		},
		userCollaborators() {
			const currentRoleCollaborator = '';
			if (this.rundown && this.rundown.id) {
				const data = this.user && this.user.collaborators ? this.user.collaborators : '';
				// eslint-disable-next-line
				const current = data.find(({ rundown_ids }) => rundown_ids.includes(this.rundown && this.rundown.id));
				const currentRoleCollaborator = current && current.role ? current.role : '';
				return currentRoleCollaborator;
			}
			return currentRoleCollaborator;
		},
		isUserCollaboratorOperator() {
			let roleCollaborator = false;
			if (this.user && this.user.collaborators.length >= 1) {
				const data = this.user && this.user.collaborators ? this.user.collaborators : '';
				// eslint-disable-next-line
				for (let index = 0; index < data.length; index++) {
					if (data[index].role === 'operator') {
						// eslint-disable-next-line
						return roleCollaborator = true;
					}
				}
				// eslint-disable-next-line
				return roleCollaborator = false;
			}
			return roleCollaborator;
		},
		activeRouteName() {
			return this.$route.name;
		},
		activeRouteSlug() {
			return this.$route.params.slug;
		},
		filteredDisplay() {
			const filter = item => (item.rundown_id === this.rundown.id);
			return this.displaysActive.filter(filter);
		},
		filteredStatusList() {
			const status = duplicateVar(this.statusList);
			const newArray = status.slice();
			newArray.shift();
			return newArray;
		},
	},
	created() {
		this.joinSocket();
		window.addEventListener('resize', this.onResizeWidth);
		this.onResizeWidth();
		window.addEventListener('scroll', this.handleScroll);
		// eslint-disable-next-line no-unused-vars
		const timerId = setInterval(this.updateTime, 1000);
		window.addEventListener('contextmenu', this.onClick);
		window.addEventListener('contextmenu', this.onClickRundown);
		if (this.userId) {
			this.fetchRundown();
		}
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
		window.removeEventListener('contextmenu', this.onClick);
		window.removeEventListener('contextmenu', this.onClickRundown);
	},
	watch: {
		rundown() {
		},
		activeRouteSlug() {
			if (this.activeRouteSlug) {
				this.getRundownData();
				return this.rundown;
			}
			return this.rundown;
		},
		userId() {
			if (this.userId) this.fetchRundown();
		},
		nameRundown(val) {
			this.nameRundown = val.replace(/[^A-Z0-9 ]/gi, '');
		},
	},
	mounted() {
		if (!this.rundown) this.getRundownData();
		window.addEventListener('resize', this.onResizeWidth);
		this.onResizeWidth();
	},
	beforeDestroy() {
		this.leaveSocket();
	},
};
</script>
<style>
@import '~vue-context/dist/css/vue-context.css';
</style>
